// 6 Professional Theme Configurations

export const THEMES = {
  modern_orange: {
    id: 'modern_orange',
    name: 'Modern Orange',
    description: 'Bold & Energetic',
    preview: {
      primary: '#FF5A36',
      secondary: '#E04828',
      accent: '#FFA07A'
    },
    colors: {
      primary: '#FF5A36',
      primaryDark: '#E04828',
      secondary: '#FFA07A',
      background: 'from-orange-50 via-red-50 to-pink-50',
      headerBg: 'from-orange-500 to-red-600',
      cardBorder: 'border-orange-200',
      cardHover: 'hover:border-orange-500',
      text: 'text-orange-600',
      badge: 'bg-orange-100 text-orange-800',
      button: 'bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700'
    },
    pattern: 'dots'
  },

  royal_purple: {
    id: 'royal_purple',
    name: 'Royal Purple',
    description: 'Elegant & Premium',
    preview: {
      primary: '#8B5CF6',
      secondary: '#7C3AED',
      accent: '#A78BFA'
    },
    colors: {
      primary: '#8B5CF6',
      primaryDark: '#7C3AED',
      secondary: '#A78BFA',
      background: 'from-purple-50 via-violet-50 to-indigo-50',
      headerBg: 'from-purple-600 to-indigo-700',
      cardBorder: 'border-purple-200',
      cardHover: 'hover:border-purple-500',
      text: 'text-purple-600',
      badge: 'bg-purple-100 text-purple-800',
      button: 'bg-gradient-to-r from-purple-600 to-indigo-700 hover:from-purple-700 hover:to-indigo-800'
    },
    pattern: 'waves'
  },

  ocean_blue: {
    id: 'ocean_blue',
    name: 'Ocean Blue',
    description: 'Professional & Trust',
    preview: {
      primary: '#0EA5E9',
      secondary: '#0284C7',
      accent: '#38BDF8'
    },
    colors: {
      primary: '#0EA5E9',
      primaryDark: '#0284C7',
      secondary: '#38BDF8',
      background: 'from-blue-50 via-cyan-50 to-sky-50',
      headerBg: 'from-blue-600 to-cyan-700',
      cardBorder: 'border-blue-200',
      cardHover: 'hover:border-blue-500',
      text: 'text-blue-600',
      badge: 'bg-blue-100 text-blue-800',
      button: 'bg-gradient-to-r from-blue-600 to-cyan-700 hover:from-blue-700 hover:to-cyan-800'
    },
    pattern: 'grid'
  },

  forest_green: {
    id: 'forest_green',
    name: 'Forest Green',
    description: 'Fresh & Natural',
    preview: {
      primary: '#10B981',
      secondary: '#059669',
      accent: '#34D399'
    },
    colors: {
      primary: '#10B981',
      primaryDark: '#059669',
      secondary: '#34D399',
      background: 'from-green-50 via-emerald-50 to-teal-50',
      headerBg: 'from-green-600 to-emerald-700',
      cardBorder: 'border-green-200',
      cardHover: 'hover:border-green-500',
      text: 'text-green-600',
      badge: 'bg-green-100 text-green-800',
      button: 'bg-gradient-to-r from-green-600 to-emerald-700 hover:from-green-700 hover:to-emerald-800'
    },
    pattern: 'diagonal'
  },

  sunset_pink: {
    id: 'sunset_pink',
    name: 'Sunset Pink',
    description: 'Creative & Vibrant',
    preview: {
      primary: '#EC4899',
      secondary: '#DB2777',
      accent: '#F472B6'
    },
    colors: {
      primary: '#EC4899',
      primaryDark: '#DB2777',
      secondary: '#F472B6',
      background: 'from-pink-50 via-rose-50 to-fuchsia-50',
      headerBg: 'from-pink-600 to-rose-700',
      cardBorder: 'border-pink-200',
      cardHover: 'hover:border-pink-500',
      text: 'text-pink-600',
      badge: 'bg-pink-100 text-pink-800',
      button: 'bg-gradient-to-r from-pink-600 to-rose-700 hover:from-pink-700 hover:to-rose-800'
    },
    pattern: 'circles'
  },

  dark_mode: {
    id: 'dark_mode',
    name: 'Dark Mode',
    description: 'Pure Black & Sleek',
    preview: {
      primary: '#FFFFFF',
      secondary: '#A1A1AA',
      accent: '#3B82F6'
    },
    colors: {
      primary: '#FFFFFF',
      primaryDark: '#E4E4E7',
      secondary: '#3B82F6',
      background: 'from-black via-zinc-950 to-black',
      headerBg: 'from-black to-zinc-900',
      cardBorder: 'border-zinc-800',
      cardHover: 'hover:border-zinc-600',
      text: 'text-white',
      badge: 'bg-zinc-800 text-zinc-200',
      button: 'bg-white text-black hover:bg-zinc-200',
      isDark: true,
      textLight: 'text-white',
      textMuted: 'text-zinc-400'
    },
    pattern: 'hexagons'
  }
};

// Background patterns as SVG data URIs
export const PATTERNS = {
  dots: "data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='1' fill='%23000' opacity='0.05'/%3E%3C/svg%3E",
  
  waves: "data:image/svg+xml,%3Csvg width='100' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 10 Q 25 0, 50 10 T 100 10' stroke='%23000' opacity='0.05' fill='none'/%3E%3C/svg%3E",
  
  grid: "data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M 40 0 L 0 0 0 40' fill='none' stroke='%23000' opacity='0.05'/%3E%3C/svg%3E",
  
  diagonal: "data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 40 L40 0 M0 0 L40 40' stroke='%23000' opacity='0.05'/%3E%3C/svg%3E",
  
  circles: "data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30' cy='30' r='25' stroke='%23000' fill='none' opacity='0.05'/%3E%3C/svg%3E",
  
  hexagons: "data:image/svg+xml,%3Csvg width='50' height='43.3' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 0 L50 12.5 L50 30.8 L25 43.3 L0 30.8 L0 12.5 Z' fill='none' stroke='%23000' opacity='0.08'/%3E%3C/svg%3E"
};

export const getTheme = (themeId) => {
  // Map old theme id to new one
  if (themeId === 'dark_elite') {
    themeId = 'dark_mode';
  }
  return THEMES[themeId] || THEMES.modern_orange;
};

export const getAllThemes = () => {
  return Object.values(THEMES);
};
